<template>
    <div id="ChooseCompany" class="starter-template" :key="key">
        <b-container fluid>
            <b-row class="text-center" style="padding-top: 6px">
                <b-col>
                    <div class="text-center shad">
                        <h4 class="txtShad">{{ $t('DEF_AREA') }}</h4>
                    </div>
                </b-col>
            </b-row>
            <b-row align-h="center" style="padding-top: 6px">
                <b-col cols="1"></b-col>
                <b-col>
                    <div class="tbl1Name text-center">
                        <h5 class="txtShad">{{ $t('COUNTRY') }}</h5>
                    </div>
                    <b-form-select
                            v-if="intLoc=='ru'"
                            v-model="selCountryRu"
                            :options="optCountryRu"
                            @change="chCountry('ru')"
                    >
                    </b-form-select>
                    <b-form-select
                            v-else
                            v-model="selCountryEn"
                            :options="optCountryEn"
                            @change="chCountry('en')"
                    >
                    </b-form-select>
                </b-col>
                <b-col>
                    <div v-if="optDistrictRu[0].text">
                        <div class="tbl1Name text-center">
                            <h5 class="txtShad">{{ $t('DISTRICT') }}</h5>
                        </div>
                        <b-form-select
                                v-if="intLoc=='ru'"
                                v-model="selDistrictRu"
                                :options="optDistrictRu"
                                @change="chDistrict('ru')"
                        >
                        </b-form-select>
                        <b-form-select
                                v-else
                                v-model="selDistrictEn"
                                :options="optDistrictEn"
                                @change="chDistrict('en')"
                        >
                        </b-form-select>
                    </div>
                </b-col>
                <b-col>
                    <div v-if="optCityRu[0].text">
                        <div class="tbl1Name text-center">
                            <h5 class="txtShad">{{ $t('CITY') }}</h5>
                        </div>
                        <b-form-select
                                v-if="intLoc=='ru'"
                                v-model="selCityRu"
                                :options="optCityRu"
                                @change="chCity('ru')"
                        >
                        </b-form-select>
                        <b-form-select
                                v-else
                                v-model="selCityEn"
                                :options="optCityEn"
                                @change="chCity('en')"
                        >
                        </b-form-select>
                    </div>
                </b-col>
                <b-col cols="1"></b-col>
            </b-row>
        </b-container>
        <br>
        <b-container v-if="selected === 'business'">
            <b-row >
                    <div class="tbl1Name shad">
                        <h4 class="txtShad text-center">{{ $t('COMPANIES') }}</h4>
                    </div>
                    <b-table class="backWhite descOuter mt-2"
                             id="listTableC"
                             selectable
                             :items="itemsC"
                             :fields="fields"
                             :per-page=0
                             :current-page="curPageC"
                             striped
                             head-row-variant="info"
                             @row-selected="onRowSelectedC"
                    >
                    </b-table>

                    <b-pagination v-if="listLengthC>10"
                                  v-model="curPageC"
                                  :total-rows="rowsC"
                                  :per-page="perPage"
                                  aria-controls="listTableC"
                                  pills
                    ></b-pagination>
            </b-row>
            <br><br><br>
        </b-container>

        <b-container fluid class="footer text-center">
            <b-row>
                <b-col>
                    <b-form-radio-group id="radio-group-2" v-model="selected" name="radio-sub-component">
                        <b-button class="m-1" @click="company.companyName = ''; close()">{{$t('CLOSE')}}
                        </b-button>
                        <b-button class="m-1">
                            <span  v-b-popover.hover.top="this.$t('CLEAR')" @click="clear()">
                                <font-awesome-icon icon="broom" size="lg"/>
                            </span>
                        </b-button>
                    </b-form-radio-group>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { BContainer, BRow, BCol, BButton, BFormSelect, BTable, BPagination, BFormRadioGroup} from 'bootstrap-vue';

export default {
  name: 'ChooseCompany',
  components: {
    BContainer, BRow, BCol, BButton, BFormSelect, BTable, BPagination, BFormRadioGroup
  },
  data: function() {
    return {
        key: 0,
        userName: '',
        curUserName: '',
        company: {},
        itemName: '',
        itemType: '',
        countryRu: '',
        countryEn: '',
        districtRu: '',
        districtEn: '',
        city: '',
        river: '',
        lake: '',
        mountain: '',
        selCountryRu: '',
        selCountryEn: '',
        optCountryRu: [{}],
        optCountryEn: [{}],
        selDistrictRu: '',
        selDistrictEn: '',
        optDistrictRu: [{}],
        optDistrictEn: [{}],
        selCityRu: '',
        selCityEn: '',
        optCityRu: [{}],
        optCityEn: [{}],
        sure: null,
        refType: null,
        intLoc: this.$i18n.locale,
        item: '',
        itemsC: [{}],
        selectedC: null,
        listLengthC: 1,
        perPage: 10,
        curPageC: 1,
        geoType: '',
        selected: 'business',
        chsnGeo: '',
        untieGeo: false,
        showMapBtn: false,
        individ: 'false',
        selWayType: [],
        selSubjType: [],
        modalShow: false
    }
  },
  mounted() {
    this.curUserName = this.$store.state.curUserName;
    this.getGeoCompanies();
    this.getCountries();
  },
  methods: {
    async getCountries() {
        this.chsnGeo = 'country';
        try {
            //alert(this.selected);
            const response = await this.$http.get('/getCountries', {
                params: {
                    resType: this.selected,
                    intLoc: this.intLoc
                }
            });
            this.optCountryRu = response.data.optRefsRu;
            this.optCountryEn = response.data.optRefsEn;
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async getDistricts() {
        this.chsnGeo = 'district';
        this.selDistrictRu = '';
        this.selDistrictEn = '';
        this.selCityRu = '';
        this.selCityEn = '';
        this.optDistrictRu = [{}],
        this.optDistrictEn = [{}],
        this.optCityRu = [{}],
        this.optCityEn = [{}],
        this.itemsC = [{}];
        try {
            const response = await this.$http.get('/getDistricts', {
                params: {
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    resType: this.selected,
                    intLoc: this.intLoc
                }
            });
            if(typeof response.data == 'undefined' || response.data == '') return;
            this.optDistrictRu = response.data.optRefsRu;
            this.optDistrictEn = response.data.optRefsEn;
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async getCities() {
        this.chsnGeo = 'city';
        try {
            const response = await this.$http.get('/getCities', {
                params: {
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    resType: this.selected,
                    intLoc: this.intLoc
                }
            });
            if(typeof response.data == 'undefined' || response.data == '') return;
            this.optCityRu = response.data.optRefsRu;
            this.optCityEn = response.data.optRefsEn;
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    chCountry(code) {
        //alert(code);
        this.showMapBtn = true;
        if(code==='ru') {
            this.countryRu = this.optCountryRu[this.selCountryRu].text;
            this.countryEn = this.optCountryEn[this.selCountryRu].text;
            this.selCountryEn = this.optCountryEn[this.selCountryRu].value;
        } else {
            this.countryEn = this.optCountryEn[this.selCountryEn].text;
            this.countryRu = this.optCountryRu[this.selCountryEn].text;
            this.selCountryRu = this.optCountryRu[this.selCountryEn].value;
        }
        this.selDistrictRu=''; this.selDistrictEn=''; this.selCityRu=''; this.selCityEn='';
        this.geoType = 'country';
        if(this.selected === 'business') {
            this.getGeoCompanies();
            //this.getGeoPlaces();
        }
        else this.getGeoOutings();
        this.getDistricts();
    },
    chDistrict(code) {
        if(code==='ru') {
            this.districtRu = this.optDistrictRu[this.selDistrictRu].text;
            this.districtEn = this.optDistrictEn[this.selDistrictRu].text;
            this.selDistrictEn = this.optDistrictEn[this.selDistrictRu].value;
        } else {
            this.districtEn = this.optDistrictEn[this.selDistrictEn].text;
            this.districtRu = this.optDistrictRu[this.selDistrictEn].text;
            this.selCountryRu = this.optDistrictRu[this.selDistrictEn].value;
        }
        this.geoType = 'district';
        this.selCityRu=''; this.selCityEn='';
        if(this.selected === 'business') {
            this.getGeoCompanies();
            //this.getGeoPlaces();
        }
        else this.getGeoOutings();
        this.getCities();
    },
    chCity(code) {
        if(code==='ru') {
            this.cityRu = this.optCityRu[this.selCityRu].text;
            this.cityEn = this.optCityEn[this.selCityRu].text;
            this.selCityEn = this.optCityEn[this.selCityRu].value;
        } else {
            this.cityEn = this.optCityEn[this.selCityEn].text;
            this.cityRu = this.optCityRu[this.selCityEn].text;
            this.selCityRu = this.optCityRu[this.selCityEn].value;
        }
        this.geoType = 'city';
        if(this.selected === 'business') {
            this.getGeoCompanies();
            //this.getGeoPlaces();
        }
        else this.getGeoOutings();
    },
    async getGeoCompanies() {
        if(!this.geoType) return;
        try {
            const response = await this.$http.get('/getGeoCompanies', {
                params: {
                    geoType: this.geoType,
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    listLoc: this.intLoc,
                    pageNum: this.curPageC
                }
            });
            this.itemsC = response.data.itemList;
            this.listLengthC = response.data.listLen;
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    chListLoc(newListLoc) {
        this.intLoc = newListLoc;
        this.curPageC = 1;
        this.selCountryRu = 'Россия';
        this.selCountryEn = 'Russia';
        this.selDistrictRu = '';
        this.selDistrictEn = '';
        this.selCityRu = '';
        this.selCityEn = '';
        this.itemsC = [];
    },
    async onRowSelectedC(items) {
        this.item = items[0];
        this.companyName = items[0].itemName;
        this.homeUrl = items[0].userName;
        this.close();
    },
    clear() {
        this.geoType = '';
        this.selCountryRu = '';
        this.selCountryEn = '';
        this.selDistrictRu = '';
        this.selDistrictEn = '';
        this.selCityRu = '';
        this.selCityEn = '';
        this.optCountryRu = [{}],
        this.optCountryEn = [{}],
        this.optDistrictRu = [{}],
        this.optDistrictEn = [{}],
        this.optCityRu = [{}],
        this.optCityEn = [{}],
        this.getCountries();
        this.itemsC = [{}];
        this.listLengthC = 0;
    },
    getCom() {
        return this.companyName;
    },
    getHomeUrl() {
        return this.homeUrl;
    },
    close() {
        this.$emit('retToOut');
    }
  },
  watch: {
    '$store.state.intLoc': function() {
        this.intLoc = this.$store.state.intLoc;
        this.key++;
        this.clear();
        //this.getCountries();
    },
    curPageC: function() {
        this.getGeoCompanies();
    },
    selected: function() {
        if(this.chsnGeo === 'country') this.getCountries(this.listLoc);
        else if (this.chsnGeo === 'district') this.getDistricts(this.listLoc);
        else if (this.chsnGeo === 'city') this.getCities(this.listLoc);
        if(this.selected === 'express') {
            this.getGeoCompanies();
            //this.getGeoPlaces();
        }
        else this.getGeoOutings();
    }
  },
  computed: {
    rowsC() {
        return this.listLengthC;
    },
    fields() {
      return [
        { key: 'itemName', label:  this.$t('TITLE') },
        { key: 'userName', label: this.$t('URL_HOME') }
      ]
    }
  }
}

</script>

<style>
</style>